import { render, staticRenderFns } from "./ListPmArea.vue?vue&type=template&id=6210ac1e&scoped=true&"
import script from "./ListPmArea.vue?vue&type=script&lang=js&"
export * from "./ListPmArea.vue?vue&type=script&lang=js&"
import style0 from "./ListPmArea.vue?vue&type=style&index=0&id=6210ac1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6210ac1e",
  null
  
)

export default component.exports